import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { createStyles, withStyles } from '@material-ui/styles';
import { border } from '@topconagriculture/theme';
import classNames from 'classnames';
import * as React from 'react';
import { compose, pure } from 'recompose';
const styles = (theme) => createStyles({
    list: {
        overflowY: 'auto',
    },
    tableHeader: {
        height: 26,
        verticalAlign: 'bottom',
    },
    tableHeaderElement: {
        fontWeight: theme.font.weight.bold,
        fontSize: theme.font.size.mediumBig,
        borderBottom: border(theme.color.grey.darkest, 2),
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 5,
        color: theme.color.font.dark,
    },
    listItem: {
        height: 65,
        borderBottom: border(theme.color.grey.default),
        fontSize: theme.font.size.mediumBig,
        '&:last-child': {
            borderBottom: 'none',
            '& $listItemColumn': {
                borderBottom: 'none',
            },
        },
    },
    listItemColumn: {
        paddingLeft: 0,
    },
});
const HeaderTableCells = ({ columns, className, testId }) => {
    return columns.map(({ rowDataKey, headerLabel = '', headerProps }) => (React.createElement(TableCell, Object.assign({ "data-testid": `${testId}-header-cell-${rowDataKey}`, key: rowDataKey, className: className }, headerProps), headerLabel)));
};
const BodyTableRows = ({ rows, columns, bodyRowClassName, bodyCellClassName, keyField, testId }) => {
    return rows.map((cellData) => {
        return (React.createElement(TableRow, { key: cellData[keyField], className: bodyRowClassName },
            React.createElement(BodyTableCells, { columns: columns, cellData: cellData, className: bodyCellClassName, testId: testId })));
    });
};
const BodyTableCells = ({ columns, cellData, className, testId }) => {
    return columns.map(({ rowDataKey, component, columnProps }) => {
        const renderComponentOrCellData = component ? component(cellData) : cellData[rowDataKey];
        return (React.createElement(TableCell, Object.assign({ "data-testid": `${testId}-body-cell-${cellData.id}`, key: `${cellData.id}-${rowDataKey}`, className: className }, columnProps), renderComponentOrCellData));
    });
};
const TableList = (props) => {
    const { classes, columnsConfig, headerClassName, bodyRowClassName, bodyCellClassName, rowsData, keyField, testId = 'TableList', } = props;
    const headerClassNames = classNames(classes.tableHeaderElement, headerClassName);
    const bodyRowClassNames = classNames(classes.listItem, bodyRowClassName);
    const bodyCellClassNames = classNames(classes.listItemColumn, bodyCellClassName);
    return (React.createElement("div", { className: classes.list, "data-testid": `${testId}` },
        React.createElement(Table, null,
            React.createElement(TableHead, { "data-testid": `${testId}-head` },
                React.createElement(TableRow, { className: classes.tableHeader, "data-testid": `${testId}-header-row` },
                    React.createElement(HeaderTableCells, { columns: columnsConfig, className: headerClassNames, testId: testId }))),
            React.createElement(TableBody, { "data-testid": `${testId}-body` },
                React.createElement(BodyTableRows, { testId: testId, keyField: keyField || 'id', rows: rowsData, columns: columnsConfig, bodyRowClassName: bodyRowClassNames, bodyCellClassName: bodyCellClassNames })))));
};
const ComposedTableList = compose(withStyles(styles, { withTheme: true }), pure)(TableList);
ComposedTableList.displayName = 'TableList';
export default ComposedTableList;
//# sourceMappingURL=Table.js.map